import { GlobalMessageSaveDetails } from "../types/globalMessageTypes";

export const globalMessageSaveInitialValues: GlobalMessageSaveDetails = {
  id: null,
  name: "",
  nameEn: "",
  text: "",
  textEn: "",
  type: {},
  enabled: undefined,
};
